"use strict";

import React, { useState, useEffect } from "react";
import { HexColorPicker, HexColorInput } from "react-colorful";

const ColorPicker = ({ value, onChange, presetColors }) => {
    const [color, setColor] = useState(value);
    useEffect(() => {
        onChange(color);
    }, [color]);
    return (
        <>
            <div className="tde-picker-btns">
                {presetColors.map((presetColor, index) => (
                    <button
                        key={presetColor}
                        className="tde-picker-btn"
                        data-index={index}
                        autoFocus={index === 0}
                        style={{ background: presetColor }}
                        onClick={() => setColor(presetColor)}
                    />
                ))}
            </div>
            <HexColorPicker color={color} onChange={setColor} />
            <div className="tde-d-flex tde-picker-input">
                <div>#</div>
                <HexColorInput
                    className="tde-input tde-input-text tde-flex-1"
                    style={{ borderLeft: 0 }}
                    color={color}
                    onChange={setColor}
                />
            </div>
        </>
    );
};

class ColorPickerComponent extends React.Component {
    handleChange = (color) => {
        // Trigger change color after timeout.
        if (this.changeTimeout) {
            clearTimeout(this.changeTimeout);
        }
        this.changeTimeout = setTimeout(() => {
            this.props.handleChange({ hex: color }, this.props.name);
        }, 300);
    };

    render = () => {
        const presetColors = this.props.presetColors || [
            "#767676",
            "#486FFB",
            "#DE51AB",
            "#7CBF31",
            "#B39329",
            "#A42124",
        ];

        return (
            <div className="tde-color-picker" style={this.props.style}>
                <ColorPicker
                    value={this.props.color}
                    onChange={this.handleChange}
                    presetColors={presetColors}
                />
            </div>
        );
    };
}

export default ColorPickerComponent;
